import React, { useContext, useEffect, useState } from 'react';
import Select from 'react-select';
import { OrgUserListContext } from '../../context/OrgUserListContext';

function UserTimesheetSelect({
    isPermission = false,
    permission,
    setUserHash,
    viewerData,
    userHash,
    isDisabled,
}) {
    const { orgUserListState } = useContext(OrgUserListContext);
    const [userOptions, setUserOptions] = useState([]);
    const [showInfo, setShowInfo] = useState(false);

    let user = null;
    if (userOptions?.length) {
        user =
            permission === 'superadmin' &&
            !userOptions.find((user) => user.value === userHash)
                ? userOptions[0]
                : userOptions.find((user) => user.value === userHash);
    }

    useEffect(() => {
        userHash && user?.value && setUserHash(user.value);
    }, [user]);

    useEffect(() => {
        if (orgUserListState?.data) {
            const options = orgUserListState.data.map((user) => {
                let label = user?.user_name ? user?.user_name : user.email;
                return {
                    value: user.hash,
                    label: label,
                };
            });
            setUserOptions(options);
        } else {
            setUserOptions([]);
        }
    }, [orgUserListState]);

    useEffect(() => {
        !userOptions.length && !orgUserListState?.loading && setUserHash(null);
    }, [userOptions]);

    function handleSelectChange(value) {
        user = value;
        setUserHash(value.value);
    }

    const setCustomStyle = () => ({
        control: (provided) => ({
            ...provided,
            padding: '2px 0',
            width: '310px',
            outline: 'none',
            boxShadow: 'none',
            backgroundColor: 'transparent',
            opacity: '1',
            height: '42px',
            borderColor: '#dbeafe',
            '&:hover': {
                borderColor: '#dbeafe',
                backgroundColor: '#f3f4f6',
            },
            cursor: 'pointer',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#c2c7d7',
            '&:hover': {
                color: '#86899f',
            },
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            color: '#484a53',
            opacity: '1',
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            color: '#c2c7d7',
            opacity: '1',
            cursor: 'pointer',
            '&:hover': {
                color: '#86899f',
            },
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            backgroundColor: '#c2c7d7',
            opacity: '1',
        }),
    });


    return (
        <div className="relative">
            {isDisabled ? (
                <p className="text-2xl font-light text-gray-700">
                    {user?.label}
                </p>
            ) : (
                <Select
                    name={'user'}
                    value={user}
                    options={userOptions}
                    onChange={(value) => handleSelectChange(value)}
                    styles={setCustomStyle()}
                    isDisabled={isDisabled}
                />
            )}
        </div>
    );
}

export default UserTimesheetSelect;
